<template>
    <div>
         <div class="order_nav">
            <nav-bar 
            :titleText="advertising_name" 
            @goBack="goBack" 
            :righticonshow="true" 
            :righticon="righticon" 
            @rightclick="supportBS"></nav-bar>
        </div>
        <div class="rules_content">
            <img :src="RulesPhoto" alt="">
        </div>
    </div>
</template>
<script>
import navBar from "../components/navBar";

export default {
    data(){
        return{
            advertising_name:'三年购补贴攻略说明',
            righticon:require("@/assets/third/selfSupport/more_icon_grey.png"),
            RulesPhoto:'',
            shopId:8,
            callback:false
        }
    },
    components:{
        navBar
    },
    created(){
        this.getRules();
        this.callback = this.$route.query.callback;
    },
    methods:{
        getRules(){
            this.$api.get("onshop/index/shop/get/typ/activity/direction").then((res)=>{
                if(res){
                    this.RulesPhoto = res.direction;
                }
            })
        },
        goBack(){
            if(this.callback){
                this.$router.go(-1);
            }else{
                this.params("", "", "goBack");
            }
        },
        supportBS(){
            this.params(this.shopId, this.shopId, "supportThreeYearBS");
        }
    },
    mounted() {
        document.documentElement.style.setProperty("font-size", (document.body.clientWidth / 375) * 10 + "px");
        window.onresize = ()=>{
            document.documentElement.style.setProperty("font-size", (document.body.clientWidth / 375) * 10 + "px");
        }
    }
}
</script>
<style lang="less" scoped>
.order_nav{
    position: fixed;
    width: 100%;
    z-index: 999999;
}
.rules_content{
    width: 100%;
    position: fixed;
    height: calc(100% - 7.5rem);
    position: relative;
    top: 7.5rem;
    &>img{
        width: 100%;
        display: block;
    }
}
</style>